import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "./logos/logo_atomic_crm_dark.svg";
export const defaultLightModeLogo = "./logos/logo_atomic_crm_light.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "Atomic CRM";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

// Prospecting statuses for the padel-prospecting workflow (mirrors the
// spreadsheet's colored "Statut" dropdown column). User-extendable via
// Settings -> Notes.
export const defaultNoteStatuses = [
  {
    value: "a_recontacter",
    label: "A recontacter",
    color: "#7dbde8",
    visibleInDealsKanban: true,
  },
  {
    value: "visio",
    label: "Visio",
    color: "#e88b7d",
    visibleInDealsKanban: true,
  },
  {
    value: "en_discussion",
    label: "En discussion",
    color: "#e8c47d",
    visibleInDealsKanban: true,
  },
  {
    value: "client",
    label: "Client",
    color: "#7de88f",
    visibleInDealsKanban: true,
  },
  {
    value: "mort",
    label: "Mort",
    color: "#c47de8",
    visibleInDealsKanban: false,
  },
  {
    value: "rdv_sur_place",
    label: "rdv sur place",
    color: "#e87da1",
    visibleInDealsKanban: true,
  },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

export const defaultClientChecklist = [
  { value: "first-tournament", label: "Premier tournoi créé ensemble" },
  { value: "stripe-connected", label: "Compte Stripe connecté" },
  { value: "mouja-installed", label: "Extension MOJA installée" },
  {
    value: "advantage-system-configured",
    label: "Explication et paramétrage du système d’avantage",
  },
];

export const defaultClubChecklist = defaultClientChecklist.filter((item) =>
  ["stripe-connected", "advantage-system-configured"].includes(item.value),
);
export const defaultRefereeChecklist = defaultClientChecklist.filter((item) =>
  ["mouja-installed", "first-tournament"].includes(item.value),
);

export const splitLegacyClientChecklist = (
  items: typeof defaultClientChecklist,
) => ({
  clubChecklist: items.filter((item) =>
    ["stripe-connected", "advantage-system-configured"].includes(item.value),
  ),
  refereeChecklist: items.filter(
    (item) =>
      !["stripe-connected", "advantage-system-configured"].includes(item.value),
  ),
});

export const normalizeClientChecklist = <
  T extends { value?: string; label: string },
>(
  items: T[] | undefined,
) =>
  items?.map((item) =>
    item.value === "mouja-installed" &&
    item.label === "Extension Mouja installée"
      ? { ...item, label: "Extension MOJA installée" }
      : item,
  ) ?? [];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  clientChecklist: defaultClientChecklist,
  clubChecklist: defaultClubChecklist,
  refereeChecklist: defaultRefereeChecklist,
  currency: defaultCurrency,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
